export default [

    {
        path: '/accounting-metrics',
        name: 'accounting-metrics',
        component: () => import('@/views/accounting/metrics/MetricsListing.vue'),
        meta: {
            pageTitle: 'Sustainability Analytics',
            breadcrumb: [
                {
                    text: 'Metrics',
                    active: true,
                },
            ], 
            //permissions: PermissionList.Accounting.View
        },
    },

]